import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { prepareAndSetStorageData } from '../../../adapters/book-widget-postData/postData-storage.adapter';
import { PostDataSearchLocalStorage } from '../../../models/postData-search-local-storage.interface';
import { UtilsService } from '../../../services/utils.service';
import * as fromBookWidgetActions from '../../actions/book-widget.actions';
import * as fromPostDataActions from '../../actions/post-data.action';
import {
  getBookWidgetFields,
  getBookWidgetFieldsErrorCount
} from '../../selectors/book-widget.selectors';
import { getCacheKeySuffix } from '../../selectors/default-lookup.selectors';

@Injectable({
  providedIn: 'root'
})
export class FindFlightsInitEffects {
  defaultValueEvaluation$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(fromBookWidgetActions.FindFlightProceed),
        concatLatestFrom(() =>
          this.store.select(getBookWidgetFieldsErrorCount)
        ),
        filter(([, fieldsErrorCount]) => fieldsErrorCount === 0),
        concatLatestFrom(() => [this.store.select(getCacheKeySuffix)]),
        switchMap(([, cacheKeySuffix]) => {
          if (cacheKeySuffix) {
            return of(
              fromPostDataActions.UpdateSearchPostData({
                cacheKeySuffix
              })
            );
          }
          return of(fromPostDataActions.LoadDefaultLookupSearch());
        })
      )
  );

  updateSearchPostData$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(fromPostDataActions.UpdateSearchPostData),
        concatLatestFrom(() => [this.store.select(getBookWidgetFields)]),
        switchMap(([{ cacheKeySuffix }, bookWidgetFields]) => {
          return from(
            prepareAndSetStorageData(
              cacheKeySuffix,
              bookWidgetFields,
              this.utilsService
            )
          ).pipe(
            switchMap(({ redirectionPage, postDataSearch }) => {
              return of(
                fromPostDataActions.LoadUpdateSearchApi({
                  postDataSearch: postDataSearch as PostDataSearchLocalStorage,
                  redirectToPage: redirectionPage,
                  cacheKeySuffix
                })
              );
            })
          );
        })
      )
  );

  constructor(
    private Actions$: Actions,
    private store: Store,
    private utilsService: UtilsService
  ) {}
}
